var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"3rd Party Credit"}},[_c('div',{staticClass:"d-flex align-items-center"},[_c('b',[_vm._v("2Captcha")]),_c('span',{staticClass:"ml-auto"},[_vm._v("$ 980")])])])}
var staticRenderFns = []

export { render, staticRenderFns }